import { createAction } from 'redux-actions';

export const SET_PLATFORM_DATA = 'SET_PLATFORM_DATA';

export const setPlatformData = createAction(SET_PLATFORM_DATA);
